var $ = jQuery.noConflict();

/* Script on ready
------------------------------------------------------------------------------*/
$(document).ready(function () {
    $(".amor-offer-popup .modal").addClass('isvisible');
    var cookieshowhide = $.cookie('size-COOKIE'); 
    if(cookieshowhide == 1) { 
        $(".amor-offer-popup .modal").addClass('is-active');
    }
    $('#modal-close_cookies').click(function(){
        $.cookie("size-COOKIE", 1, { expires : 7 });
        $(".amor-offer-popup .modal").addClass('is-active'); 
    });
   $('.home-page .collection .product-grid').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      autoplay: false,
      arrows: true,
      responsive: [{
            breakpoint: 1069,
            settings: {
               slidesToShow: 2
            }
         },
         {
            breakpoint: 768,
            settings: {
               slidesToShow: 2,
            }
         },
         {
            breakpoint: 580,
            settings: {
               slidesToShow: 1
            }
         }
      ]
   });

   $('.modal-toggle-chart').on('click', function(e) {
    e.preventDefault();
    $('.modal').toggleClass('is-visible');
  });

  
});
